/**
 * @ngdoc controllers
 * @memberof mercury.modules.time
 * @name TimePayrunEditwagesCtrl
 */
angular.module('mercury.modules.time.payroll.payrun')
.controller('TimePayrollPayrunEditwagesCtrl', ["$scope", "TimeClock", "TimePayrollPayruns", function($scope, TimeClock, TimePayrollPayruns) {

  function refresh() {
    $scope.outofrangeError = false;
    angular.forEach($scope.payrunLine.clockins, function(clock) {
      clock.outofrange = $scope.isClockOutOfRange(clock, $scope.payrunLine);
      $scope.outofrangeError = $scope.outofrangeError || clock.outofrange;

      clock.length = moment(clock.clockoutTime).diff(clock.clockinTime, 'minutes') / 60;
    });
  }

  refresh();

  $scope.includedClocksModel = {};
  angular.forEach($scope.payrunLine.includedClockins, function(payrunLineClockin) {
    $scope.includedClocksModel[payrunLineClockin.clockinId] = true;
  });

  /**
   * Save changes to a clockin to the server.
   */
  $scope.saveClockin = function(clockin) {
    if (!clockin.hourlyRate) {
      clockin.hourlyRate = 0;
    }
    TimeClock.update(clockin)
    .then(function(savedClock) {
      clockin.id = savedClock.id;
      clockin.clockinTime = savedClock.clockinTime;
      clockin.clockoutTime = savedClock.clockoutTime;
      clockin.isCompanyClockin = savedClock.isCompanyClockin;
      clockin.hourlyRate = savedClock.hourlyRate;
      clockin.adjustedHourlyRate = savedClock.adjustedHourlyRate;
      clockin.rules = savedClock.rules;

      if (savedClock.datestampDeleted) {
        angular.forEach($scope.payrunLine.clockins, function(clock, index) {
          if (clock.id == savedClock.id) {
            $scope.payrunLine.clockins.splice(index, 1);
          }
        });
      }

      $scope.updateTotals($scope.payrunLine);

      refresh();
    });
  };

  $scope.changeClockInclude = function(clockinId) {
    if ($scope.includedClocksModel[clockinId] === true) {
      $scope.payrunLine.includedClockins.push({clockinId: clockinId});
    } else {
      angular.forEach($scope.payrunLine.includedClockins, function(includedClock, index) {
        if (includedClock.clockinId == clockinId) {
          $scope.payrunLine.includedClockins.splice(index, 1);
        }
      });
    }

    $scope.updateTotals($scope.payrunLine);

    refresh();
  };

  /**
   * Add a new clock to the staff member which the wage editor dialog is open
   */
  $scope.wagesAddClock = function() {
    TimeClock.create({
      clockinTime: $scope.payrunLine.datestampStart,
      clockoutTime: moment($scope.payrunLine.datestampStart).add('hours', 3).format(),
      staffMemberId: $scope.payrunLine.staffMemberId
    }).then(function(result) {
      $scope.payrunLine.clockins.push(result);

      $scope.updateTotals($scope.payrunLine);

      refresh();
    });
  };

  var pullUnpaid = function() {
    $scope.unpaidShift = null;
    TimeClock.getLastUnpaid($scope.payrunLine.staffMemberId, $scope.payrunLine.datestampStart)
    .then(function(result) {
      if (result.id) {
        $scope.unpaidShift = result;
        if ($scope.unpaidShift !== null) {
          $scope.unpaidShift.length = TimeClock.getClockinLength($scope.unpaidShift.clockoutTime, $scope.unpaidShift.clockinTime);
        }
      }
    });
  };

  pullUnpaid();

  $scope.changeBackpay = function() {
    TimePayrollPayruns.getNewLine($scope.payrunLine.datestampStart, $scope.payrun.datestampEnd, $scope.payrunLine.staffMemberId)
    .then(function(result) {
      angular.forEach(result.clockins, function(clock) {
        clock.length = TimeClock.getClockinLength($scope.unpaidShift.clockoutTime, $scope.unpaidShift.clockinTime);
      });
      $scope.payrunLine.clockins = result.clockins;

      pullUnpaid();
    });
  };

  $scope.deleteClock = function(clockin) {
    clockin.datestampDeleted = moment().format();
    $scope.saveClockin(clockin)
    .then(function() {
      refresh();
    });
  };
}]);
